import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  actionablefill as actionable,
  adsfill as ads,
  areafill as area,
  dashboardfill as dashboard,
  growth,
  marketfill as market,
  referfill as refer,
  salesfill as sales,
  suggestionsfill as suggestions,
  billfill,
  timefill as time,
} from "../../../images";

const iconMap = {
  Home: "bi-house",
  Dashboard: dashboard,
  "Ad Insights": ads,
  "Marketplace Accounts": market,
  "Geographical Sales Insights": sales,
  "Time Lens": time,
  "Product Growth": growth,
  Order: "bi-bag-check",
  "Report Processing": "bi-file-earmark-bar-graph",
  Settings: "bi-gear",
  "Interactive Sales Map": sales,
  Profile: "bi-person",
  "Area Wise Insights": area,
  "State Wise Sales": "bi-map",
  City: "bi-map",
  "Pin Code": "bi-map",
  "Review Rating": "bi-chat-left-text",
  "Suggestion Portal": suggestions,
  Referral: refer,
  "Seller Radar": actionable,
  "Billing Section": billfill,
  "Notification":"bi-bell",
  "Notifications":"bi-bell",
  "Notification Settings":"bi-bell",
  "Ad Keywords": ads
};

const Breadcrumb = ({
  categoryName,
  categoryId,
  onBreadcrumbClick,
  defaultRange,
  viewType,
  componentType,
}) => {
  const location = useLocation();
  const breadcrumbRef = useRef(null);
  const navigate = useNavigate();
  const [showLeftFade, setShowLeftFade] = useState(false);
  const [showRightFade, setShowRightFade] = useState(false);

  const generateBaseTrail = (componentType = null) => {
    let paths;
    if (componentType === "invoiceHistory") {
        return [{ label :"Billing Section", path: '/billing-section' }];
    } else {
      paths = location.pathname.split("/").filter(Boolean);
      return paths.map((path, index) => {
        const fullPath = "/" + paths.slice(0, index + 1).join("/");
        const label = decodeURIComponent(
          path
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        );
        return { label, path: fullPath, categoryId: null };
      });
    }
  };

  const [breadcrumbTrail, setBreadcrumbTrail] = useState(
    generateBaseTrail(componentType)
  );

  useEffect(() => {
    setBreadcrumbTrail(generateBaseTrail(componentType));
  }, [defaultRange, viewType]);

  useEffect(() => {
    if (categoryName && categoryId) {
      const last = breadcrumbTrail[breadcrumbTrail.length - 1];
      if (last?.categoryId !== categoryId && last?.label !== categoryName) {
        setBreadcrumbTrail((prev) => [
          ...prev,
          { label: categoryName, categoryId },
        ]);
      }
    }
  }, [categoryName, categoryId]);

  //  Handle scroll fade indicators
  const updateScrollFades = () => {
    const el = breadcrumbRef.current;
    if (!el) return;
    setShowLeftFade(el.scrollLeft > 5);
    setShowRightFade(el.scrollWidth - el.clientWidth - el.scrollLeft > 5);
  };

  useEffect(() => {
    const el = breadcrumbRef.current;
    if (el) {
      updateScrollFades();
      el.addEventListener("scroll", updateScrollFades);
      window.addEventListener("resize", updateScrollFades);
    }
    return () => {
      if (el) el.removeEventListener("scroll", updateScrollFades);
      window.removeEventListener("resize", updateScrollFades);
    };
  }, [breadcrumbTrail]);

  const handleBreadcrumbClick = (index, breadcrumb) => {
    if (componentType === "invoiceHistory") {
      navigate(-1);
      return;
    }
    if (componentType === "notification"){
      navigate(-1);
      return;
    }
    const newTrail = breadcrumbTrail.slice(0, index + 1);
    setBreadcrumbTrail(newTrail);

    const isDynamicFirst = index === 0 && breadcrumb.categoryId;
    const isCampaignLevel = location.pathname === "/ad-keywords";
    if (typeof onBreadcrumbClick === "function") {
      if (isCampaignLevel) {
        onBreadcrumbClick(index, breadcrumb);
        return;
      }
      if (isDynamicFirst) {
        onBreadcrumbClick(null, breadcrumb.label);
      } else if (breadcrumb.categoryId) {
        onBreadcrumbClick(breadcrumb.categoryId, breadcrumb.label);
      } else {
        onBreadcrumbClick(null, breadcrumb.label);
      }
    } else if (breadcrumb.path && breadcrumb.path !== location.pathname) {
      navigate(breadcrumb.path);
    }
  };

  return (
    <div className=" breadcrumb-wrapper common-component-header">
      <nav aria-label="breadcrumb" className="breadcrumb-nav">
        {/* First item pinned */}
        {breadcrumbTrail.length > 0 && (
          <div className="breadcrumb-fixed">
            {(() => {
              const breadcrumb = breadcrumbTrail[0];
              const icon = iconMap[breadcrumb.label];
              return (
                <div
                  className={`breadcrumb-item link-breadcrumb d-flex align-items-center ${
                    breadcrumbTrail.length > 1 ? "cursor-pointer" : ""
                  }`}
                  onClick={() => handleBreadcrumbClick(0, breadcrumb)}
                >
                  {typeof icon === "string" && icon.startsWith("bi-") ? (
                    <i className={`bi ${icon} me-1 ps-3`}></i>
                  ) : (
                    <img
                      src={icon}
                      alt={breadcrumb.label || "Breadcrumb icon"}
                      className="me-1"
                      style={{ width: "20px", height: "20px" }}
                    />
                  )}
                  <span className="breadcrumb-label">{breadcrumb.label}</span>
                </div>
              );
            })()}
            {breadcrumbTrail.length > 1 && (
              <span className="breadcrumb-separator">›</span>
            )}
          </div>
        )}

        {/* Scrollable rest */}
        <ol className="breadcrumb-scroll" ref={breadcrumbRef}>
          {breadcrumbTrail.slice(1).map((breadcrumb, index) => {
            const isLast = index === breadcrumbTrail.length - 2;
            const icon = iconMap[breadcrumb.label];
            return (
              <React.Fragment key={index + 1}>
                <li
                  className={`breadcrumb-item d-flex align-items-center ${
                    isLast ? "active-breadcrumb" : "link-breadcrumb"
                  }`}
                  style={{ cursor: isLast ? "default" : "pointer" }}
                  onClick={() => {
                    if (!isLast) {
                      handleBreadcrumbClick(index + 1, breadcrumb);
                    }
                  }}
                >
                  {typeof icon === "string" && icon.startsWith("bi-") ? (
                    <i className={`bi ${icon} me-1`}></i>
                  ) : (
                    <></>
                    // <img
                    //   src={icon}
                    //   alt={breadcrumb.label}
                    //   className="me-1"
                    //   style={{ width: "20px", height: "20px" }}
                    // />
                  )}
                  <span className="breadcrumb-label">{breadcrumb.label}</span>
                </li>
                {index < breadcrumbTrail.length - 2 && (
                  <li className="breadcrumb-separator">›</li>
                )}
              </React.Fragment>
            );
          })}
        </ol>

        {/*  Fade Indicators */}
        {showLeftFade && <div className="fade-left"></div>}
        {showRightFade && <div className="fade-right"></div>}
      </nav>

    </div>
  );
};

export default Breadcrumb;
